import { render, staticRenderFns } from "./CompanyButton.vue?vue&type=template&id=ab6a6dd8&"
import script from "./CompanyButton.vue?vue&type=script&lang=js&"
export * from "./CompanyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports